<template>
  <div class="frame" style="height:100vh">
    <iframe v-show="login" frameborder="0" width="100%" height="100%" scrolling="no" :src="page"></iframe>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/user";
export default {
    
  data() {
    return {
      page: "",
      login: false,
    };
  },
  mounted() {
    this.page = this.$route.query.page;
    getUserInfo().then(res=>{
        if(res.message == "Token失效，请重新登录"){
            this.login = false;
        }else{
            this.login = true;
        }
    })
  }
};
</script>

<style lang="scss" scoped>
.frame {
    background: url("../assets/match/bg.jpg") no-repeat -330px 0;
    background-size: 142% 86%;
    margin-top: -80px;
    padding-top: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/frame.vue